import { Component, OnInit ,EventEmitter,Input,Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table';


@Component({
  selector: 'app-pay-now',
  template: `<a *ngIf="paymentStatus" class="text-link" (click)="onClick()" #btnPaynow id="btnPaynow">Pay Now</a>
  `,
  styleUrls: ['./pay-now.component.scss']
})
export class PayNowComponent implements ViewCell , OnInit {

  @Input() value : string | any;
  @Input() rowData : any;
  @Output() click : EventEmitter<any> =  new EventEmitter();
 
  paymentStatus = false;
  constructor() { }

  ngOnInit() {
  	console.log("----------->",this.rowData);
  	if( +this.rowData['ps'] === 0){
  		this.paymentStatus = true;
  	}
  }
  onClick(){
  	this.click.emit(this.rowData['invoice_number']);
  }

}
